module.exports = __webpack_public_path__ + "img/PF.4ad0f065.png";